// extracted by mini-css-extract-plugin
export default {"header":"Home_header__ftI+1","title":"Home_title__5a5H3"};